// ViewportZoomController.jsx
import { useEffect } from "react";

export default function ViewportZoomController({ allow }) {
    
  useEffect(() => {
    // 1) viewport meta
    let meta = document.querySelector('meta[name="viewport"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "viewport");
      document.head.appendChild(meta);
    }

    const content = allow
      ? "width=device-width, initial-scale=1, maximum-scale=5, user-scalable=yes"
      : "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no";

    // Replace node (iOS can be finicky with dynamic updates)
    const clone = meta.cloneNode(true);
    clone.setAttribute("content", content);
    document.head.replaceChild(clone, meta);

    // 2) iOS gesture fallback (only when blocking)
    const isIOS =
      /iPad|iPhone|iPod/.test(navigator.userAgent) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

    const onGestureStart = (e) => e.preventDefault();
    const onTouchMove = (e) => { if (e.scale && e.scale !== 1) e.preventDefault(); };

    if (isIOS && !allow) {
      document.addEventListener("gesturestart", onGestureStart);
      document.addEventListener("touchmove", onTouchMove, { passive: false });
    }

    document.documentElement.classList.toggle("allow-zoom", !!allow);
    document.documentElement.classList.toggle("block-zoom", !allow);


    return () => {
      if (isIOS && !allow) {
        document.removeEventListener("gesturestart", onGestureStart);
        document.removeEventListener("touchmove", onTouchMove);
      }
    };
  }, [allow]);

  return null;
}
